export default __webpack_public_path__ + "b796022bd67d65f87da7d5374091163f.png";